import { useState } from 'react';
import { useParams } from 'react-router-dom';

import Form from './components/Form';
import { Success } from './components/Success';

export function AdminUsersEdit() {
  const [isSuccess, setIsSuccess] = useState(false);
  const { id } = useParams();

  function handleSuccess(value: boolean) {
    setIsSuccess(value);
  }

  return (
    <>
      {isSuccess && <Success />}
      {!isSuccess && <Form id={id} onSuccess={handleSuccess} />}
    </>
  );
}
